import { normalize } from 'normalizr';
import * as api from '../api';
import * as ZoneSchema from 'saas/pco/zones/api/schema';
import * as ZoneApi from 'saas/pco/zones/api';
import { getIsFetching } from '../reducers/zones';

export const FETCH_ZONES = 'intervention.FETCH_ZONES';
export const FETCH_ZONES_SUCCESS = 'intervention.FETCH_ZONES_SUCCESS';
export const CREATE_ZONE = 'intervention.CREATE_ZONE';
export const CREATE_ZONE_SUCCESS = 'intervention.CREATE_ZONE_SUCCESS';
export const CREATE_ZONE_ERROR = 'intervention.CREATE_ZONE_ERROR';
export const COPY_ZONE = 'intervention.COPY_ZONE';
export const COPY_ZONE_SUCCESS = 'intervention.COPY_ZONE_SUCCESS';
export const COPY_ZONE_ERROR = 'intervention.COPY_ZONE_ERROR';

const requestZones = () => ({
  type: FETCH_ZONES,
});

const receiveZones = response => ({
  type: FETCH_ZONES_SUCCESS,
  response: normalize(response, ZoneSchema.arrayOfZones),
});

const zoneCreated = response => ({
  type: CREATE_ZONE_SUCCESS,
  response: normalize(response, ZoneSchema.zone),
});

const zoneCopied = response => ({
  type: COPY_ZONE_SUCCESS,
  response: normalize(response, ZoneSchema.zone),
});

const zoneCreateError = response => ({
  type: CREATE_ZONE_ERROR,
});

export const fetchZones = (intervention, task) => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestZones());

  // Request interventions fetching then planning
  return api
    .getZones(intervention, task)
    .then(response => dispatch(receiveZones(response)));
};

export const createZone = (
  interventionId,
  taskType,
  data,
  comment
) => dispatch => {
  dispatch({
    type: CREATE_ZONE,
  });

  return ZoneApi.createZone(interventionId, taskType, data, comment).then(
    response => dispatch(zoneCreated(response)),
    error => {
      console.log(error.res);
      if (error.res.status === 409) {
        dispatch(zoneCreateError(error));
      } else {
        console.log('Unknow error creating zone: ' + error);
      }
    }
  );
};

export const copyZone = (
  interventionId,
  taskType,
  zoneId,
  zoneTemplateId,
  fromTemplate
) => dispatch => {
  dispatch({
    type: COPY_ZONE,
  });

  return ZoneApi.copyZone(
    interventionId,
    taskType,
    zoneId,
    zoneTemplateId,
    fromTemplate
  ).then(response => dispatch(zoneCopied(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/zones.js